import type { Container } from "inversify";

export function autobindIoC(container: Container, services: any) {
    
    for (const serviceKey of Object.keys(services)) {
        const service = services[serviceKey as keyof typeof services];
        //explicit scope to for each service
        container.bind<any>(service).to(service).inSingletonScope();
    }
}